import colors from "./colors";

export default {
    palette: {
        background: {
            default: colors.white
        },
        error: {
            main: colors.red
        },
        primary: {
            main: colors.green
        },
        secondary: {
            main: colors.blue
        },
        common: {
            white: colors.white,
            grey: colors.lightGrey
        },
        default: {
            main: colors.lightGrey
        }
    },
    typography: {
        fontFamily: ["Cabin", "sans-serif"].join(",")
    },
    components: {
        MuiButton: {
            styleOverrides: {
                /** Theming structure */
                containedPrimary: {
                    color: colors.white
                },
                outlinedPrimary: {
                    color: colors.green
                },
                containedSecondary: {
                    color: colors.white
                },
                outlinedSecondary: {
                    color: colors.blue
                },
                containedError: {
                    background: colors.red,
                    color: colors.white
                },
                outlinedError: {
                    color: colors.red
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                /** Theming structure */
                root: {}
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "& .Mui-selected": {
                        fontSize: "0.70rem",
                        // backgroundColor: theme.palette.secondary.main,,
                        // color: theme.palette.secondary.contrastText,
                        borderRadius: "25px"
                    }
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                footerContainer: {
                    "& svg": {
                        color: colors.green
                    }
                }
            }
        }
    },
    overrides: {},
    shape: {
        borderRadius: 1
    }
};
